import { Routes } from '@angular/router';
import { MainpageComponent } from './mainpage/mainpage.component';
import { HomepageComponent } from './homepage/homepage.component';
import { MainWebpageComponent } from './mainwebpage/mainwebpage.component';
import { AdminpageComponent } from './adminpage/adminpage.component';
import { authGuard } from './auth.guard';
import { LoginregisterComponent } from './loginregister/loginregister.component';
export const routes: Routes = [
  {
    path: '',
    component: MainWebpageComponent,
  },
  {
    path: 'main',
    component: MainpageComponent,
  },
  {
    path: 'home',
    component: HomepageComponent,
  },
  {
    path: 'adminpage',
    component: AdminpageComponent,
    canActivate: [authGuard]
  },
  {
    path: 'login',
    component: LoginregisterComponent,
  },
  {
    path: '**',
    redirectTo: '',
  }
];

// export const routes: Routes = [
//   {
//     path: '',
//     redirectTo: 'EnlightenPhysioSpot',
//     pathMatch: 'full',
//   },
//   {
//     path: 'main',
//     component: MainpageComponent,
//   },
//   {
//     path: 'home',
//     component: HomepageComponent,
//   },
//   {
//     path:'EnlightenPhysioSpot',
//     component:MainWebpageComponent,
//     // canActivate: [authGuard] // 🔐 protected
//   },
//   {
//     path: 'adminpage',
//     component: AdminpageComponent,
//     canActivate: [authGuard] // 🔐 protected
//   },
//   {
//     path: 'login',
//     component: LoginregisterComponent,
//   },
//   {
//     path: '**',
//     redirectTo: 'EnlightenPhysioSpot',
//   }
// ];
